import { useState, useEffect } from "react";
import { useRecoilState } from "recoil";
import Layout from "../components/layout/Layout";
import { uploadDocs } from "../dashboardRow";
import { useModalState } from "../hooks/useModel";
import UploadModel from "../model/UploadModel";
import { catag } from "../state/catagory";
import MyList from "./ListReports";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import {
  Grid,
  Box,
  Typography,
  Container,
  CardContent,
  CardHeader,
  Paper,
  useTheme,
} from "@mui/material";

import DataGrid from "react-data-grid";
import "react-data-grid/lib/styles.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import FilePreview from "../components/FilePreview";
import "../styles/UploadReport.model.css";
import { Document, Page, pdfjs } from "react-pdf";
import { ErrorBoundary } from "../error-boundary";

import { useSelector } from "react-redux";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const UploadReports = ({ files }) => {
  const [activeMenu, setActiveMenu] = useState(0);

  const [, setData] = useRecoilState(catag);

  const { open, handleOpen, handleClose } = useModalState(false);
  const theme = useTheme();

  const [currentSessionFiles] = useState([]);
  const [file, setFile] = useState(null);
  const [fileContent, setFileContent] = useState(null);
  const [numPages, setNumPages] = useState(null);

  const [selectedFile, setSelectedFile] = useState(null);
  const selectedCompanyId = useSelector((state) => state.kyc.selectedCompanyId);

  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");

  useEffect(() => {}, [selectedFile]);

  const columns =
    (fileContent && Object.keys(fileContent[0]))?.map((key) => ({
      key: key,
      name: key,
      resizable: true,
      sortable: true,
    })) || [];

  useEffect(() => {
    if (activeMenu === 0) {
      setData((prevData) => ({
        ...prevData,
        category: "Invoices",
      }));
    } else if (activeMenu === 1) {
      setData((prevData) => ({
        ...prevData,
        category: "Bank Statement",
      }));
    } else if (activeMenu === 2) {
      setData((prevData) => ({
        ...prevData,
        category: "Other Docs",
      }));
    } else if (activeMenu === 3) {
      setData((prevData) => ({
        ...prevData,
        category: "Reports",
      }));
    }

    return () => {
      <></>;
    };
  }, [activeMenu]);

  const handleSubCategory = (inv) => {
    setSelectedCategory(uploadDocs[activeMenu].category);
    setSelectedSubCategory(inv.name);
    setData((prevData) => ({
      ...prevData,
      subcategory: inv.name,
    }));
    handleOpen();
  };

  const onFileUpload = (category, subCategory, fileType, fileDetails) => {};

  return (
    <Layout>
      <Container maxWidth="xl" sx={{ py: 2 }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper
              elevation={2}
              sx={{
                backgroundColor: "#e57373",
                p: 2,
                borderRadius: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 2,
                  flexWrap: "wrap",
                }}
              >
                {uploadDocs.map((category, index) => (
                  <Box
                    key={index}
                    onClick={() => setActiveMenu(index)}
                    sx={{
                      padding: "8px 16px",
                      backgroundColor:
                        activeMenu === index
                          ? theme.palette.primary.main
                          : "transparent",
                      color: "white",
                      cursor: "pointer",
                      borderRadius: 1,
                      transition: "all 0.3s ease",
                      minWidth: "120px",
                      textAlign: "center",
                      "&:hover": {
                        backgroundColor:
                          activeMenu === index
                            ? theme.palette.primary.main
                            : theme.palette.primary.light,
                      },
                    }}
                  >
                    <Typography
                      variant="body2"
                      fontWeight="medium"
                      sx={{ color: "white" }}
                    >
                      {category.category}
                    </Typography>
                  </Box>
                ))}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  mt: 0.5,
                }}
              ></Box>
            </Paper>
          </Grid>

          <Grid item xs={12} md={8}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <Paper
                elevation={2}
                sx={{
                  backgroundColor: (theme) => theme.palette.secondary.main,
                  borderRadius: 2,
                  minHeight: "200px",
                }}
              >
                <CardContent sx={{ p: 3 }}>
                  <Box sx={{ mb: 3 }}>
                    <Typography
                      variant="h5"
                      component="h2"
                      sx={{ mb: 2, color: "black" }}
                    >
                      {uploadDocs[activeMenu].category}
                    </Typography>

                    <Grid container spacing={2}>
                      {uploadDocs[activeMenu].subCategory?.map((inv, i) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
                          <Button
                            size="small"
                            variant="contained"
                            sx={{
                              backgroundColor: (theme) =>
                                theme.palette.primary.main,
                              color: "white",
                              width: "150px",
                              textTransform: "none",
                              transition: "all 0.3s ease",
                              "&:hover": {
                                transform: "translateY(-2px)",
                                boxShadow: 3,
                                backgroundColor: (theme) =>
                                  theme.palette.primary.dark,
                              },
                            }}
                            onClick={() => handleSubCategory(inv)}
                          >
                            <Typography
                              variant="body2"
                              fontWeight="medium"
                              color="white"
                            >
                              {inv?.name}
                            </Typography>
                          </Button>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>

                  {activeMenu === 1 && (
                    <Box sx={{ mb: 3 }}>
                      <Link
                        to="/bankstatement"
                        style={{ textDecoration: "none" }}
                      >
                        <Button
                          variant="contained"
                          size="small"
                          sx={{
                            backgroundColor: (theme) =>
                              theme.palette.primary.secondary,
                            color: "white",
                            "&:hover": {
                              backgroundColor: (theme) =>
                                theme.palette.primary.dark,
                            },
                          }}
                        >
                          Analysis
                        </Button>
                      </Link>
                    </Box>
                  )}

                  <ErrorBoundary>
                    {file && !fileContent && (
                      <Paper
                        elevation={1}
                        sx={{
                          maxHeight: "500px",
                          overflow: "auto",
                          p: 2,
                          mt: 2,
                          backgroundColor: "white",
                        }}
                      >
                        <Typography variant="h6" sx={{ mb: 2 }}>
                          PDF Preview
                        </Typography>
                        <Document
                          file={file}
                          onLoadSuccess={({ numPages }) =>
                            setNumPages(numPages)
                          }
                        >
                          {Array.from(new Array(numPages), (el, index) => (
                            <Page
                              key={`page_${index + 1}`}
                              pageNumber={index + 1}
                            />
                          ))}
                        </Document>
                      </Paper>
                    )}
                  </ErrorBoundary>

                  <ErrorBoundary>
                    {file &&
                      file.headers &&
                      file.headers["content-type"] ===
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
                      fileContent && (
                        <Paper
                          elevation={1}
                          sx={{
                            mt: 2,
                            p: 2,
                            height: "400px",
                            backgroundColor: "white",
                          }}
                        >
                          <Typography variant="h6" sx={{ mb: 2 }}>
                            Excel Data
                          </Typography>
                          <Box sx={{ height: "350px" }}>
                            <DataGrid
                              key={file.data.id}
                              columns={columns}
                              rows={fileContent}
                            />
                          </Box>
                        </Paper>
                      )}
                  </ErrorBoundary>
                </CardContent>
              </Paper>

              <Paper
                elevation={2}
                sx={{
                  borderRadius: 2,
                }}
              >
                <MyList
                  setFile={setFile}
                  currentSessionFiles={currentSessionFiles}
                  setFileContent={setFileContent}
                  setSelectedFile={setSelectedFile}
                />
              </Paper>
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Paper
              elevation={2}
              sx={{
                backgroundColor: "#F8EEDB",
                borderRadius: 2,
                minHeight: "500px",
              }}
            >
              <CardHeader
                title={
                  <Typography variant="h6" sx={{ color: "black" }}>
                    File Preview
                  </Typography>
                }
                sx={{ pb: 1 }}
              />
              <CardContent>
                <UploadModel
                  open={open}
                  handleClose={handleClose}
                  category={selectedCategory}
                  subCategory={selectedSubCategory}
                  kycId={selectedCompanyId}
                  onFileUpload={onFileUpload}
                />
                <FilePreview file={selectedFile} />
              </CardContent>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default UploadReports;
